// extracted by mini-css-extract-plugin
module.exports = {"LogoutCard":"styles_LogoutCard__3cuTc"};